import { useQuery } from "@tanstack/react-query";
import { fetchJson } from "@/lib/api";
import type { CustomerContext } from "@/services/customer-context";

export type { CustomerContext } from "@/services/customer-context";

/** Historija kupca za ekran narudžbe. Dostupno samo u webhook modu — u api modu
 *  endpoint vraća 409, a pozivalac to tretira kao „nema konteksta" i sakrije blok.
 *  Zato `retry: false`: nema smisla ponavljati poziv koji ne može uspjeti. */
export function useCustomerContext(storeId: string | null, orderId: string | null) {
  return useQuery({
    queryKey: ["customer-context", storeId, orderId],
    queryFn: () =>
      fetchJson<CustomerContext>(`/api/orders/${orderId}/customer-context?storeId=${storeId}`),
    enabled: !!storeId && !!orderId,
    retry: false,
    staleTime: 60_000,
  });
}
